import Spinner from "@legacy/core/components/Spinner";
import { Component } from "react";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import SearchCreateSelectField from "../../core/fields/SearchCreateSelectField";
import TextField from "../../core/fields/TextField";
import { JobOriginTypes, JobStatuses } from "../../core/utils/enums";
import JobSubStatusSearchOrCreateSelect, { subStatusToSubStatusOption } from "../inputs/JobSubStatusSearchOrCreateSelect";


class JobChangeCompletedStatusForm extends Component {

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    renderButtons = () => {
        const { requestAction, switchToPrimaryForm, submitting, errors } = this.props

        if (errors.unexpectedError) {
            return (
                <div className="data-panel__action-feedback">
                    <span className="text-invalid"><strong>An unexpected error occurred.</strong></span>
                </div>
            )
        }
        else {
            if (submitting) {
                return <Spinner centered={true} />
            }
            else {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="primary" text="Update Completed Status" handler={event => requestAction("JOB_CHANGE_COMPLETED_STATUS_SUBMIT")} />
                        </ButtonGroupRow>
                        <ButtonGroupRow>
                            <UniversalButton type="secondary" text="Cancel" handler={event => switchToPrimaryForm()} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
        }
    }

    render() {
        const { job, changeCompletedStatusData, errors, onFormDataChange, updateSubStatusSelection, selectedSubStatus } = this.props

        return (
            <div className="data-panel-container data-panel-container--with-margin">
                <div className="data-panel" aria-label="Job Completed Status">
                    <div className="data-panel__form" aria-label="Job Completed Status Form">
                        <p className="data-panel__form__caption">Please confirm you'd like to update this job's completed status.</p>
                        <BasicDisplayField
                            fieldName="id"
                            fieldLabel="Roopairs Job ID"
                            fieldValue={job.custom_id ? job.custom_id : job.id}
                        ></BasicDisplayField>
                        {
                            job.origin_type !== JobOriginTypes.roopairs && (
                                <BasicDisplayField
                                    fieldName="origin_id"
                                    fieldLabel={`${job.origin_type_label} ID`}
                                    fieldValue={job.origin_id}
                                ></BasicDisplayField>
                            )
                        }
                        <BasicDisplayField
                            fieldName="service_name"
                            fieldLabel="Service Type"
                            fieldValue={job.service_name}
                        ></BasicDisplayField>
                        <BasicDisplayField
                            fieldName="is_job_walk"
                            fieldLabel="Job Type"
                            fieldValue={job.is_recall ? "Recall" : job.is_job_walk ? "Job Walk" : "Service"}
                        ></BasicDisplayField>
                        <SearchCreateSelectField
                            fieldName="substatus"
                            fieldLabel="Sub-Status"
                            fieldValue={selectedSubStatus}
                            inputComponent={
                                <JobSubStatusSearchOrCreateSelect
                                    onSelectionChange={selectedOption => updateSubStatusSelection(selectedOption != null ? selectedOption.object : null)}
                                    defaultSelected={selectedSubStatus !== null ? subStatusToSubStatusOption(selectedSubStatus) : null}
                                    showCreateButton={false}
                                    selectedStatus={JobStatuses.completed}
                                ></JobSubStatusSearchOrCreateSelect>
                            }
                            showButton={false}
                            errors={errors}
                        ></SearchCreateSelectField>
                        <TextField
                            key={selectedSubStatus?.id}
                            fieldName="completed_message"
                            fieldLabel={selectedSubStatus !== null && selectedSubStatus.reason_label !== "" ? selectedSubStatus.reason_label : "Completion Reason"}
                            fieldValue={changeCompletedStatusData.completed_message || ""}
                            fieldOnChange={completed_message => onFormDataChange("completed_message", completed_message || "")}
                            rows={3}
                            placeholder={selectedSubStatus?.reason_placeholder || ""}
                            optional={selectedSubStatus === null || !selectedSubStatus.reason_required}
                            errors={errors}
                        ></TextField>
                    </div>
                    {this.renderButtons()}
                </div>
            </div>
        )
    }
}

export default JobChangeCompletedStatusForm;
